import React, { memo } from 'react';
import makeStyles from '@mui/styles/makeStyles';
import { useSidePanelContext } from 'modules/rootPage/SidePanelContext';
import { useSubstituteUser } from 'modules/rootPage/hooks/useSubstituteUser';
import { useNotesBackgroudTimerContext } from 'modules/NotesBackgroudTimer/context/NotesBackgroudTimerContext';
import { CollectorListTabs } from './CollectorListTabs';
import CollectorSyncStatusContextProvider from './contexts/CollectorSyncStatusContextProvider';

type PageStyleProps = {
  pinned: boolean;
  isSubstituteUser: boolean;
  isBackgroundTimerRunning: boolean;
};

const useStyles = makeStyles((theme) => ({
  root: {
    borderRadius: 'unset',
    overflow: 'hidden',
    marginTop: ({
      isSubstituteUser,
      isBackgroundTimerRunning
    }: PageStyleProps) => {
      if (isSubstituteUser && isBackgroundTimerRunning)
        return theme.spacing(9.3);
      else if (isSubstituteUser) return theme.spacing(4);
      else if (isBackgroundTimerRunning) return theme.spacing(5.3);
      else return 'unset';
    },
    boxShadow: theme.shadow?.paper,
    backgroundColor: theme.palette.background.default,
    flexGrow: 1,
    paddingLeft: ({ pinned }: PageStyleProps) =>
      theme.spacing(pinned ? 29.8 : 7.8)
  }
}));

export const CollectorsPage: React.FC = memo(() => {
  const { isSubstituteUser } = useSubstituteUser();
  const { pinned = false } = useSidePanelContext();
  const { running: isBackgroundTimerRunning } = useNotesBackgroudTimerContext();
  const classes = useStyles({
    pinned,
    isSubstituteUser,
    isBackgroundTimerRunning
  });

  return (
    <CollectorSyncStatusContextProvider>
      <div data-testid="collectors-page" className={classes.root}>
        <CollectorListTabs />
      </div>
    </CollectorSyncStatusContextProvider>
  );
});

CollectorsPage.displayName = 'CollectorsPage';
